// import $utils from '@assets/utils'                        // 公共自定义钩子函数

export default {
  // 只调用一次，指令第一次绑定到元素时调用。在这里可以进行一次性的初始化设置。
  bind: (el, binding) => {
    let str = binding.value
    str = str.replace(/[\n\r]/g, '<br/>')
    let reg = /\$\^\S+\^\$/
    let reg2 = /\*\^\S+\^\*/
    // let reg3 = /<u>\S+<\/u>/
    if (reg.test(str) || reg2.test(str)) {
      // str = $utils.filterInput(str)
      str = str.replace(/\$\^/g, '<sup>')
      str = str.replace(/\^\$/g, '</sup>')
      str = str.replace(/\*\^/g, '<sub>')
      str = str.replace(/\^\*/g, '</sub>')
      el.innerHTML = str
    } else {
      el.innerHTML = str
    }
    if (el.children.length > 0 && el.children[0].tagName === 'IMG') {
      el.children[0].style.maxWidth = '100%'
    }
    if (el.getElementsByTagName('img').length > 0) {
      el.getElementsByTagName('img')[0].style.maxWidth = '100%'
    }
    // console.log('bind', el.getElementsByTagName('img'))
  },
  // 被绑定元素插入父节点时调用 (仅保证父节点存在，但不一定已被插入文档中)。
  inserted: (el) => {
    // console.log('inserted', el.innerHTML)
  },
  // 所在组件的 VNode 更新时调用，但是可能发生在其子 VNode 更新之前。指令的值可能发生了改变，也可能没有。但是你可以通过比较更新前后的值来忽略不必要的模板更新
  update: (el) => {
    // console.log('update', el.innerHTML)
  },
  // 指令所在组件的 VNode 及其子 VNode 全部更新后调用。
  componentUpdated: (el, binding) => {
    let str = binding.value
    str = str.replace(/[\n\r]/g, '<br/>')
    let reg = /\$\^\S+\^\$/
    let reg2 = /\*\^\S+\^\*/
    if (reg.test(str) || reg2.test(str)) {
      // str = $utils.filterInput(str)
      str = str.replace(/\$\^/g, '<sup>')
      str = str.replace(/\^\$/g, '</sup>')
      str = str.replace(/\*\^/g, '<sub>')
      str = str.replace(/\^\*/g, '</sub>')
      el.innerHTML = str
    } else {
      el.innerHTML = str
    }
    if (el.children.length > 0 && el.children[0].tagName === 'IMG') {
      el.children[0].style.maxWidth = '100%'
    }
    if (el.getElementsByTagName('img').length > 0) {
      el.getElementsByTagName('img')[0].style.maxWidth = '100%'
    }
    // console.log(str)
  },
  // 只调用一次，指令与元素解绑时调用。
  unbind: (el) => {
    // console.log('unbind', el.innerHTML)
  }
}



// WEBPACK FOOTER //
// ./src/instruction/power.js